import React, { useEffect, useRef } from "react";
import { DUCK_FRAMES } from "./cityAssets";
import { drawOutfit } from "./cityRenderer";

export default function CityDuck({ duckRef, size }) {
  const ov = useRef(null);
  useEffect(() => {
    let raf, last = "";
    const tick = () => {
      const d = duckRef.current, c = ov.current;
      if (d && c) { const k = d.dataset.outfit || "{}"; if (k !== last) { last = k; const ctx = c.getContext("2d"); ctx.clearRect(0, 0, c.width, c.height); drawOutfit(ctx, JSON.parse(k), c.width / 2, 2, size, 1); } }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [duckRef, size]);
  return (
    <div
      ref={duckRef}
      className="cq-city-duck absolute left-0 top-0 pointer-events-none will-change-transform"
      style={{ width: size * 0.7, height: size, transformOrigin: "50% 0", opacity: 0 }}
      data-testid="city-duck"
    >
      <div className="absolute left-1/2 -translate-x-1/2 rounded-full bg-black/40 blur-[2px]" style={{ width: size * 0.45, height: size * 0.07, top: size * 0.96 }} />
      <canvas ref={ov} width={size} height={size} className="absolute left-1/2 -translate-x-1/2 top-0 pointer-events-none" style={{ width: size, height: size }} />
      {DUCK_FRAMES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          draggable={false}
          data-frame={i}
          className="cq-duck-frame absolute inset-x-0 bottom-0 mx-auto h-full w-auto object-contain object-bottom select-none"
          style={{ display: i === 0 ? "block" : "none" }}
        />
      ))}
    </div>
  );
}
